<mat-progress-bar
  *ngIf="submiting"
  color="primary"
  mode="indeterminate"
></mat-progress-bar>
<mat-card class="mat-elevation-z6" [ngClass]="{ loading: submiting }">
  <div mat-card-image>
    <img src="assets/images/icon.png" alt="" />
  </div>

  <mat-card-header>
    <mat-card-title> Faça login para continuar </mat-card-title>
    <mat-card-subtitle>
      Informe seu email para acessar sua conta ou fazer seu primeiro cadastro
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="form">
      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Seu email</mat-label>
          <input
            type="email"
            matInput
            placeholder="Informe seu email"
            formControlName="email"
          />
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>

  <mat-card-actions>
    <button
      class="custom-primary"
      mat-raised-button
      (click)="submit()"
      [disabled]="submiting"
    >
      Continuar
    </button>
    <button
      class="azul"
      mat-raised-button
      (click)="confirmAccount()"
      style="float: left; margin: 0"
    >
      Criar Conta
    </button>
  </mat-card-actions>
</mat-card>
